import React from "react";
import { RecipesSvg } from "assets/icons/RecipesSvg";
import { SiteRegistrationSvg } from "assets/icons/SiteRegistrationSvg";
import { SitesSvg } from "assets/icons/SitesSvg";
import { ProfileSvg } from "assets/icons/ProfileSvg";
import SiteRegistrationLottie from "assets/lotties/SiteRegistrationLottie.json";
import ChemicalRecipeLottie from "assets/lotties/ChemicalRecipeLottie.json";
import ShareLottie from "assets/lotties/ShareLottie.json";
import PlantedAcresLottie from "assets/lotties/PlantedAcresLottie.json";
import UserRegistrationLottie from "assets/lotties/UserRegistrationLottie.json";
import packageJson from "../../package.json";

export const APP_VERSION = packageJson.version;

export const USER_NOT_CONFIRMED_CODE = "USER_NOT_CONFIRMED";

export const REACT_SELECT_STYLES = {
  control: (provided) => ({
    ...provided,
    border: "none",
    borderBottom: `1px solid var(--theme-light-gray)`,
    boxShadow: "none",
    borderRadius: 0,
    "&:hover": {
      borderBottom: `1px solid var(--theme-light-gray)`,
    },
    fontSize: "15px",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0px 4px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "var(--theme-label-gray)",
    fontWeight: 300,
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#000",
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "14px",
    zIndex: 1000,
  }),
};

export const SITE_REGISTRATION_LOTTIE_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: SiteRegistrationLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const CHEMICAL_RECIPE_LOTTIE_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: ChemicalRecipeLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const SHARE_LOTTIE_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: ShareLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const PLANTED_ACRES_LOTTIE_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: PlantedAcresLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const USER_REGISTRATION_LOTTIE_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: UserRegistrationLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const PATH_TO_LINK = {
  "/site-registration": "site-registration",
  "/sites": "sites",
  "/recipes": "recipes",
  "/profile": "profile",
};

export const ROUTES = [
  {
    label: "My Sites",
    route: "sites",
    icon: <SitesSvg />,
  },
  {
    label: "Site Registration",
    route: "site-registration",
    icon: <SiteRegistrationSvg />,
  },
  {
    label: "Chemical Recipes",
    route: "recipes",
    icon: <RecipesSvg />,
  },
  {
    label: "My Profile",
    route: "profile",
    icon: <ProfileSvg />,
  },
];
export const CHEMICAL_DETAILS = [
  {
    name: "Terminate",
    manufacturer: "Nufarm Americas, Inc",
    activeIngredients: "Ethephon 6.0 pounds + Cyclanilide.375 pounds",
    brandName: "Finish 6 Pro Harvest Aid by Bayer",
  },
  {
    name: "Super Boll",
    manufacturer: "Nufarm Americas, Inc",
    activeIngredients: "Ethephon 6.0 pounds",
    brandName: "Prep by Bayer",
  },
  {
    name: "Tapran",
    manufacturer: "CHS, Inc",
    activeIngredients: "Complex crop oil blend",
    brandName: "Tapran by CHS",
  },
  {
    name: "Helmquat 3SL",
    manufacturer: "Helm Agro US, Inc",
    activeIngredients: "Paraquat 3.0 Pounds",
    brandName: "Gramoxone SL 3.0 by Syngenta",
  },
];
export const CHEMICAL_UNITS = [
  {
    name: "Fluid Ounce",
    value: "fl oz/ac",
  },
  {
    name: "Ounce",
    value: "oz/ac",
  },
];

export const BASE_YEAR = 2024;
export const PATTERNS = ["Solid"];

export const MODE_TYPES = {
  ADD: "add",
  EDIT: "edit",
};

export const SHARE_TYPES = {
  SINGLE: "single",
  MULTIPLE: "multiple",
};

export const DATE_TYPES = {
  SINGLE: "single",
  RANGE: "range",
};

export const PLANTING_STATUS = {
  PLANNED: "Planned",
  ACTIVE: "Active",
  FAILED: "Failed",
  HARVESTED: "Harvested",
};

export const NOTES_STATUS = {
  PENDING: "Pending",
  RESOLVED: "Resolved",
};

export const NOTES_TYPES = {
  SITE: "site",
  PLANTED_ACRES: "crop",
  RECIPE: "recipe",
  USAGE: "usage",
};

export const US_STATES = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const TAB_KEYS = {
  REGISTERED_SITES: "registered-sites",
  SHARED_SITES: "shared-sites",
  SHARED_RECIPES: "shared-recipes",
  OWNED_RECIPES: "owned-recipes",
  ARCHIVED_RECIPES: "archived-recipes",
};

// Map tile URLs and attributions
export const MAP_TILES = {
  STREET_VIEW: {
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  },
  SATELLITE_WITH_LABELS: {
    url: "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}",
    attribution:
      '&copy; <a href="https://www.google.com/intl/en_us/help/terms_maps/">Google</a>',
  },
  SATELLITE_WITHOUT_LABELS: {
    url: "http://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}",
    attribution:
      '&copy; <a href="https://www.google.com/intl/en_us/help/terms_maps/">Google</a>',
  },
};

export const DATE_FORMAT = "MM/dd/yyyy";
export const MAX_CHEMICALS_ALLOWED = 20;

export const LOCAL_STORAGE_KEYS = {
  EMAIL: "email",
  ID_TOKEN: "idToken",
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  SESSION_EXPIRED: "sessionExpired",
};
